<template>
  <b-modal
    ref="modal"
    title="Selecione a embalagem"
    centered
    size="lg"
    no-close-on-backdrop
    @shown="aoAbrir"
    @hidden="aoFechar"
  >
    <p class="mb-4">
      Escolha como <strong>{{ produto.descricao }}</strong> será vendido.
    </p>

    <b-list-group>
      <b-list-group-item
        v-for="embalagem in embalagens"
        :key="embalagem.id_produto_embalagem"
        ref="itensEmbalagem"
        :active="idSelecionado === embalagem.id_produto_embalagem"
        class="embalagem-item"
        :class="{ 'embalagem-item-sem-quantidade': !permitirQuantidade }"
        @click="selecionar(embalagem)"
        @dblclick="confirmar"
      >
        <div class="embalagem-info">
          <strong>{{ descricaoUnidade(embalagem) }}</strong>

          <span
            v-if="embalagem.embalagem_padrao"
            class="badge badge-light ml-2"
          >
            Padrão
          </span>

          <span
            class="d-block small"
            :class="
              idSelecionado === embalagem.id_produto_embalagem
                ? 'text-white'
                : 'text-muted'
            "
          >
            Baixa
            {{
              formatarQuantidade(
                embalagem.fator_conversao * quantidadeDaEmbalagem(embalagem)
              )
            }}
            {{ descricaoUnidadeBase }} do estoque

            <template v-if="embalagem.cod_barras">
              · Cód. barras: {{ embalagem.cod_barras }}
            </template>
          </span>
        </div>

        <div
          v-if="permitirQuantidade"
          class="quantidade-embalagem"
          @click.stop
          @dblclick.stop
        >
          <b-button
            size="sm"
            variant="light"
            @click="diminuirQuantidade(embalagem)"
          >
            -
          </b-button>

          <b-form-input
            ref="inputsQuantidade"
            type="number"
            min="1"
            class="text-center quantidade-input"
            :value="quantidadeDaEmbalagem(embalagem)"
            @input="alterarQuantidade(embalagem, $event)"
            @focus="selecionar(embalagem)"
          />

          <b-button
            size="sm"
            variant="light"
            @click="aumentarQuantidade(embalagem)"
          >
            +
          </b-button>
        </div>

        <strong class="font-size-lg embalagem-total">
          {{
            formatarMoeda(
              embalagem.preco *
                (permitirQuantidade ? quantidadeDaEmbalagem(embalagem) : 1)
            )
          }}
        </strong>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <b-button variant="secondary" @click="cancelar">Cancelar</b-button>
      <b-button
        variant="primary"
        :disabled="!embalagemSelecionada"
        @click="confirmar"
      >
        Usar embalagem
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "EmbalagemProdutoModalNFe",
  props: {
    permitirQuantidade: { type: Boolean, default: false },
  },
  data() {
    return {
      produto: {},
      embalagens: [],
      idSelecionado: null,
      quantidadesEmbalagem: {},
      resolver: null,
    };
  },
  beforeDestroy() {
    this.removerAtalhosTeclado();
  },
  computed: {
    embalagemSelecionada() {
      return (
        this.embalagens.find(
          (embalagem) => embalagem.id_produto_embalagem === this.idSelecionado
        ) || null
      );
    },
    descricaoUnidadeBase() {
      const unidade = this.produto?.unidade_medida || {};
      return unidade.sigla || unidade.un || unidade.nome || "unidades";
    },
  },
  methods: {
    quantidadeDaEmbalagem(embalagem) {
      return this.quantidadesEmbalagem[embalagem.id_produto_embalagem] || 1;
    },

    alterarQuantidade(embalagem, valor) {
      const qtde = Math.max(1, Number(valor) || 1);

      this.$set(
        this.quantidadesEmbalagem,
        embalagem.id_produto_embalagem,
        qtde
      );

      this.selecionar(embalagem);
    },

    aumentarQuantidade(embalagem) {
      const atual = this.quantidadeDaEmbalagem(embalagem);

      this.$set(
        this.quantidadesEmbalagem,
        embalagem.id_produto_embalagem,
        atual + 1
      );

      this.selecionar(embalagem);
    },

    diminuirQuantidade(embalagem) {
      const atual = this.quantidadeDaEmbalagem(embalagem);

      this.$set(
        this.quantidadesEmbalagem,
        embalagem.id_produto_embalagem,
        Math.max(1, atual - 1)
      );

      this.selecionar(embalagem);
    },

    abrir({ produto, embalagemSelecionada = null }) {
      if (this.resolver) this.resolver(null);

      this.quantidadesEmbalagem = {};
      this.produto = produto || {};

      const alternativas = Array.isArray(produto?.embalagens)
        ? produto.embalagens
        : [];
      this.embalagens = [
        {
          id_produto_embalagem: "__padrao__",
          embalagem_padrao: true,
          unidade_medida: produto?.unidade_medida || null,
          preco: produto?.preco,
          fator_conversao: 1,
          cod_barras: produto?.cod_barras || null,
        },
        ...alternativas,
      ];
      const idSelecaoAtual = embalagemSelecionada?.id_produto_embalagem;
      const selecaoAtualExiste = this.embalagens.some(
        (embalagem) => embalagem.id_produto_embalagem === idSelecaoAtual
      );
      this.idSelecionado = selecaoAtualExiste
        ? idSelecaoAtual
        : this.embalagens[0]?.id_produto_embalagem ?? null;

      this.$refs.modal.show();

      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    selecionar(embalagem) {
      this.idSelecionado = embalagem.id_produto_embalagem;
    },
    aoAbrir() {
      this.removerAtalhosTeclado();
      this._atalhoTeclado = (evento) => this.tratarAtalhoTeclado(evento);
      document.addEventListener("keydown", this._atalhoTeclado);
      this.rolarParaSelecionada();
    },
    removerAtalhosTeclado() {
      if (!this._atalhoTeclado) return;
      document.removeEventListener("keydown", this._atalhoTeclado);
      this._atalhoTeclado = null;
    },
    tratarAtalhoTeclado(evento) {
      if (evento.altKey || evento.ctrlKey || evento.metaKey) return;

      const tag = evento.target?.tagName;

      if (["TEXTAREA", "SELECT"].includes(tag)) {
        if (evento.key === "Enter") {
          evento.preventDefault();
          this.confirmar();
        }

        return;
      }

      if (evento.key === "ArrowDown") {
        evento.preventDefault();
        evento.stopPropagation();
        this.navegar(1);
        return;
      }

      if (evento.key === "ArrowUp") {
        evento.preventDefault();
        evento.stopPropagation();
        this.navegar(-1);
        return;
      }

      if (evento.key === "Enter") {
        evento.preventDefault();
        evento.stopPropagation();
        this.confirmar();
      }
    },
    navegar(direcao) {
      if (!this.embalagens.length) return;

      const indiceAtual = this.embalagens.findIndex(
        (embalagem) => embalagem.id_produto_embalagem === this.idSelecionado
      );
      const inicio = indiceAtual >= 0 ? indiceAtual : 0;
      const proximoIndice =
        (inicio + direcao + this.embalagens.length) % this.embalagens.length;
      this.idSelecionado = this.embalagens[proximoIndice].id_produto_embalagem;
      this.rolarParaSelecionada();
    },
    rolarParaSelecionada() {
      this.$nextTick(() => {
        const indice = this.embalagens.findIndex(
          (embalagem) => embalagem.id_produto_embalagem === this.idSelecionado
        );
        const item = this.$refs.itensEmbalagem?.[indice];
        const elemento = item?.$el || item;
        if (elemento?.scrollIntoView) {
          elemento.scrollIntoView({ block: "nearest" });
        }
        const input = this.$refs.inputsQuantidade?.[indice];
        const campo = input?.$el || input;
        if (campo?.focus) campo.focus();
      });
    },

    confirmar() {
      if (!this.embalagemSelecionada) return;

      if (!this.permitirQuantidade) {
        this.finalizar(this.embalagemSelecionada);
        return;
      }

      const quantidade = this.quantidadeDaEmbalagem(this.embalagemSelecionada);

      this.finalizar({
        ...this.embalagemSelecionada,
        quantidade,
        unidade_base: this.produto?.unidade_medida || null,
      });
    },

    cancelar() {
      this.finalizar(null);
    },

    finalizar(resultado) {
      this.removerAtalhosTeclado();
      const resolver = this.resolver;
      this.resolver = null;
      if (resolver) resolver(resultado);
      this.$refs.modal.hide();
    },
    aoFechar() {
      this.removerAtalhosTeclado();
      if (this.resolver) {
        this.resolver(null);
        this.resolver = null;
      }
    },
    descricaoUnidade(embalagem) {
      const unidade = embalagem?.unidade_medida || {};
      if (unidade.nome && unidade.sigla) {
        return `${unidade.nome} (${unidade.sigla})`;
      }
      return unidade.nome || unidade.sigla || unidade.un || "Embalagem";
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor) || 0);
    },
    formatarQuantidade(valor) {
      return new Intl.NumberFormat("pt-BR", {
        maximumFractionDigits: 4,
      }).format(Number(valor) || 0);
    },
  },
};
</script>

<style scoped>
.embalagem-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 158px minmax(110px, max-content);
  align-items: center;
  column-gap: 16px;
}

.embalagem-item-sem-quantidade {
  grid-template-columns: minmax(0, 1fr) minmax(110px, max-content);
}

.embalagem-info {
  min-width: 0;
  overflow-wrap: anywhere;
}

.quantidade-embalagem {
  display: grid;
  grid-template-columns: 36px 70px 36px;
  align-items: center;
  gap: 8px;
  width: 158px;
}

.quantidade-input {
  width: 70px;
  min-width: 0;
}

.quantidade-embalagem .btn {
  width: 36px;
  height: 36px;
  padding: 0;
}

.embalagem-total {
  min-width: 110px;
  text-align: right;
  white-space: nowrap;
}

@media (max-width: 575.98px) {
  .embalagem-item:not(.embalagem-item-sem-quantidade) {
    grid-template-columns: minmax(0, 1fr) minmax(110px, max-content);
    gap: 8px;
  }

  .embalagem-item:not(.embalagem-item-sem-quantidade) .embalagem-info {
    grid-column: 1 / -1;
  }

  .quantidade-embalagem {
    grid-column: 1;
    grid-row: 2;
  }

  .embalagem-item:not(.embalagem-item-sem-quantidade) .embalagem-total {
    grid-column: 2;
    grid-row: 2;
  }
}

@media (max-width: 399.98px) {
  .embalagem-item:not(.embalagem-item-sem-quantidade) {
    grid-template-columns: minmax(0, 1fr);
  }

  .embalagem-item:not(.embalagem-item-sem-quantidade) .embalagem-total {
    grid-column: 1;
    grid-row: 3;
  }
}
</style>
